import React from 'react';
import { Container } from '@atlassian/jira-issue-view-common-views/src/smart-link-content/styled.tsx';
import type { ConfluenceTemplate } from '../common/constants.tsx';
import { DummyConfluenceEntryPoint } from './dummy-confluence-link-entrypoint.tsx';
import { DummyGroupContainer } from './styled.tsx';

type ConfluenceLinkProps = {
	canProvisionConfluence: boolean;
	tenantIsOnFreeEdition: boolean;
	onClickPlaceholderTemplate: (e: React.MouseEvent) => void;
	template: ConfluenceTemplate;
	projectName?: string;
	requestStatusLozengeText: string;
	showDummyLink: boolean;
};

export function ConfluenceLink({
	canProvisionConfluence,
	tenantIsOnFreeEdition,
	onClickPlaceholderTemplate,
	template,
	requestStatusLozengeText,
}: ConfluenceLinkProps) {
	return (
		<DummyGroupContainer>
			<Container>
				<DummyConfluenceEntryPoint
					templateName={template.name}
					canProvisionConfluence={canProvisionConfluence}
					onClick={onClickPlaceholderTemplate}
					tenantIsOnFreeEdition={tenantIsOnFreeEdition}
					requestStatusLozengeText={requestStatusLozengeText}
				/>
			</Container>
		</DummyGroupContainer>
	);
}
